import React from 'react';
import { CSVImport, CSVExport, URLImport } from '../CSV';
import { ClearButton } from '../ClearButton';
import { LoadSample } from '../LoadSampleButton';

interface ActionBarProps {
  onImport?: (data: string) => void;
  onSample?: (data: string) => void;
  onExport?: () => void;
  onClear?: () => void;
  sampleUrl?: string;
  showImport?: boolean;
  showSample?: boolean;
  showExport?: boolean;
  showClear?: boolean;
  showUrlImport?: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onImport,
  onExport,
  onClear,
  onSample,
  sampleUrl
}) => {
  return (
    <div className="flex justify-end gap-2 mb-4">
      {onClear && <ClearButton onClear={onClear} />}
      {sampleUrl && onSample && <LoadSample onSample={onSample} url={sampleUrl} />}
      {onImport && <URLImport onImport={onImport} />}
      {onImport && <CSVImport onImport={onImport} />}
      {onExport && <CSVExport onExport={onExport} />}
    </div>
  );
};